module.exports = __webpack_public_path__ + "img/prontuario_op2.b05fe8a0.svg";